// cn() — the canonical shadcn class merger.
// clsx handles conditional classnames, tailwind-merge resolves conflicts
// (e.g. `px-2 px-4` → `px-4`). Required by every shadcn component.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
